import { formatDateLong, formatTime } from '~/lib/DateTime';

const SeriesTime = ({ start }) => {
    return (
        <div>
            {formatDateLong(start)}&nbsp; &middot; &nbsp;
            <span className="text-gray-500">{formatTime(start)}</span>
        </div>
    );
};

export default SeriesTime;
